import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from "@sentry/react";
import frontendConfig from '@config';
import { installStaleChunkReload } from './utils/reloadOnStaleChunk';
// Initialize dayjs plugins globally before any components load
import './utils/dayjs';

// Import theme early to ensure type augmentations are loaded
import './mui/theme';

// Build marker: confirms which build a preview/deploy is serving.
console.info(`[admin] build ${import.meta.env.VITE_ENV ?? 'local'} (monorepo apps/admin)`);

// Initialize Sentry
if (frontendConfig.sentryDsn) {
  Sentry.init({
    dsn: frontendConfig.sentryDsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, sample the session when an error occurs.
  });
}

installStaleChunkReload();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
